import React from 'react';
import { aiFeatures } from '../data/mock';
import { Search, FileText, PenTool, BarChart3, Sparkles } from 'lucide-react';

const iconMap = {
  Search,
  FileText,
  PenTool,
  BarChart3
};

const AIFeatures = () => {
  return (
    <section id="ai-features" className="py-24 px-6 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <Sparkles className="w-4 h-4" />
              AI-Powered
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              {aiFeatures.headline}
            </h2>
            <p className="text-xl text-emerald-600 font-medium mb-4">
              {aiFeatures.subheadline}
            </p>
            <p className="text-slate-600 leading-relaxed mb-8">
              {aiFeatures.description}
            </p>

            {/* Features List */}
            <div className="space-y-6">
              {aiFeatures.features.map((feature, index) => {
                const Icon = iconMap[feature.icon];
                return (
                  <div key={index} className="flex gap-4 group">
                    <div className="w-10 h-10 bg-emerald-50 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-100 transition-colors">
                      {Icon && <Icon className="w-5 h-5 text-emerald-600" />}
                    </div>
                    <div>
                      <h4 className="font-semibold text-slate-900 mb-1">
                        {feature.title}
                      </h4>
                      <p className="text-slate-600 text-sm">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Visual - Image */}
          <div className="relative">
            <div className="absolute -top-20 -right-20 w-80 h-80 bg-emerald-100/50 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-teal-100/50 rounded-full blur-3xl"></div>
            
            <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-emerald-200/30">
              <img 
                src="https://images.pexels.com/photos/3184343/pexels-photo-3184343.jpeg?auto=compress&cs=tinysrgb&w=800"
                alt="Team collaborating on digital products"
                className="w-full h-auto object-cover"
              />
              {/* Overlay with gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIFeatures;
